import { render, staticRenderFns } from "./order-supplier-opup.vue?vue&type=template&id=1c463a09"
import script from "./order-supplier-opup.vue?vue&type=script&lang=js"
export * from "./order-supplier-opup.vue?vue&type=script&lang=js"
import style0 from "./order-supplier-opup.vue?vue&type=style&index=0&id=1c463a09&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports